import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';
import { Check, Circle, Sparkles, ArrowRight } from 'lucide-react';

const CHECK_LABELS = {
  photo: 'Add a profile photo',
  date_of_birth: 'Add your date of birth',
  location: 'Add your location',
  relationship_goals: 'Set your relationship goal',
  core_values: 'Choose your core values',
  bio: 'Write a short bio',
  gender: 'Add your gender',
  love_languages: 'Pick your love languages',
  faith_spiritual: 'Share your faith / beliefs',
  personality_type: 'Add your personality type',
};
// Order shown in the checklist (essentials first)
const ORDER = ['photo', 'date_of_birth', 'location', 'relationship_goals', 'core_values', 'bio', 'gender', 'love_languages', 'faith_spiritual', 'personality_type'];

export const ProfileCompletion = ({ profile, onGo }) => {
  if (!profile) return null;
  const { completion = 0, checks = {} } = profile;
  if (completion >= 100) return null;
  const items = ORDER.filter((k) => k in checks);

  return (
    <Card className="shadow-lg border-amber-200 bg-gradient-to-br from-amber-50 to-rose-50 mb-8" data-testid="profile-completion-card">
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-amber-600" />
            <div>
              <h3 className="text-lg font-semibold text-rose-900">Complete your profile</h3>
              <p className="text-sm text-gray-600">A fuller profile means better, more intentional matches.</p>
            </div>
          </div>
          <Button data-testid="complete-profile-cta" size="sm" onClick={onGo} className="bg-gradient-to-r from-amber-500 to-rose-500 hover:from-amber-600 hover:to-rose-600 text-white">
            Finish profile <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <Progress value={completion} className="h-2 flex-1" data-testid="completion-progress" />
          <span className="text-sm font-bold text-rose-700 w-12 text-right" data-testid="completion-percent">{completion}%</span>
        </div>

        <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 mt-4">
          {items.map((k) => (
            <div key={k} className="flex items-center gap-2 text-sm" data-testid={`checklist-${k}`}>
              {checks[k]
                ? <Check className="w-4 h-4 text-green-600 shrink-0" />
                : <Circle className="w-4 h-4 text-gray-300 shrink-0" />}
              <span className={checks[k] ? 'text-gray-400 line-through' : 'text-gray-700'}>{CHECK_LABELS[k]}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileCompletion;
